import { Restaurant } from '~/api-definition/definition'

export const restaurantGenre = (restaurant: Restaurant) => {
  if (restaurant.categories.length > 0) {
    return restaurant.categories
      .map((category) => category.categoryName)
      .join('・')
  }
  return ''
}

export const restaurantArea = (restaurant: Restaurant) => {
  return restaurant.areaName ?? ''
}

export const restaurantAreaAndGenre = (restaurant: Restaurant): string => {
  const genre = restaurantGenre(restaurant) ?? ''
  const area = restaurantArea(restaurant) ?? ''
  if (genre.length > 0 && area.length > 0) {
    return genre + '/' + area
  } else if (genre.length > 0) {
    return genre
  } else if (area.length > 0) {
    return area
  } else {
    return ''
  }
}

export const restaurantThumbnailImages = (
  restaurant: Restaurant,
  count: number
) => {
  const images = restaurant.thumbnailImages.slice(0, count) ?? []
  return images.length === 0
    ? undefined
    : [...Array(count)].map((_, i) => images[i])
}
